import { render, staticRenderFns } from "./Paid.vue?vue&type=template&id=2e2b2e7c&"
import script from "./Paid.vue?vue&type=script&lang=js&"
export * from "./Paid.vue?vue&type=script&lang=js&"
import style0 from "./Paid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports